export default __webpack_public_path__ + "media/images/carousel/16-eaf085e0af32968efb79cbbd72dfa268.jpg";